import r from"./image-bitmap-data-url-worker";function t(){const t=new Blob([r]);return URL.createObjectURL(t)}export{t as getImageBitmapDataUrlWorkerURL};
